import React from 'react';
import { motion } from 'framer-motion';
import Icon from './Icon';
import Blueprint from './Blueprint';
import TiltCard from '../motion/TiltCard';
import { projectMedia } from '../data/site';

const STATUS_CLASS = { Completed: 'badge-success', Ongoing: 'badge-warning', Upcoming: 'badge-blue' };
const ease = [0.76, 0, 0.24, 1];

/* Project with real photos: cinematic card — photo wipes in, zooms on hover, details slide up */
function PhotoCard({ project, media, onOpen, big }) {
  // The wrapper watches the viewport (a clipped element can't), the inner card does the wipe reveal.
  return (
    <motion.div className="ph-wrap" initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }}>
      <motion.button type="button" className={`ph-card${big ? ' big' : ''}`} onClick={() => onOpen?.(project)} aria-label={`Open ${project.title}`}
        variants={{ hidden: { clipPath: 'inset(100% 0% 0% 0% round 28px)' }, show: { clipPath: 'inset(0% 0% 0% 0% round 28px)', transition: { duration: 1.1, ease } } }}>
        <motion.img src={media.coverSm} srcSet={`${media.coverSm} 800w, ${media.cover} 1600w`} sizes={big ? '(max-width: 900px) 100vw, 66vw' : '(max-width: 900px) 100vw, 33vw'}
          alt={project.title} loading="lazy" decoding="async"
          variants={{ hidden: { scale: 1.3 }, show: { scale: 1, transition: { duration: 1.6, ease: [0.22, 1, 0.36, 1] } } }} />
        <span className="ph-shade" />
        <span className="ph-top">
          {project.status && <span className={`badge ${STATUS_CLASS[project.status] || 'badge-blue'}`}>{project.status}</span>}
          {media.gallery.length > 1 && <span className="ph-count"><Icon name="layers" size={13} />{media.gallery.length} photos</span>}
        </span>
        <span className="ph-body">
          <span className="ph-cat">{project.category}</span>
          <span className="ph-title">{project.title}</span>
          <span className="ph-more">
            <span className="ph-loc"><Icon name="pin" size={14} />{project.location}</span>
            {project.scope && <span className="ph-scope">{project.scope}</span>}
          </span>
        </span>
        <span className="ph-view"><Icon name="arrow" size={20} /></span>
      </motion.button>
    </motion.div>
  );
}

/* Project without photos yet: blueprint card with an animated line drawing */
function BlueprintCard({ project }) {
  return (
    <TiltCard className="bp-card" max={6} scale={1.01}>
      <div className="bp-art"><Blueprint category={project.category} /></div>
      <div className="bp-body">
        <div className="bp-row">
          <span className="ph-cat">{project.category}</span>
          {project.status && <span className={`badge ${STATUS_CLASS[project.status] || 'badge-blue'}`}>{project.status}</span>}
        </div>
        <h3>{project.title}</h3>
        {project.location && <span className="bp-meta"><Icon name="pin" size={14} />{project.location}</span>}
        {project.scope && <p className="bp-scope">{project.scope}</p>}
        <span className="bp-soon"><span className="live-dot" style={{ background: 'var(--primary)' }} />Site photos coming soon</span>
      </div>
    </TiltCard>
  );
}

export default function ProjectCard({ project, onOpen, big = false }) {
  const media = projectMedia(project);
  return media ? <PhotoCard project={project} media={media} onOpen={onOpen} big={big} /> : <BlueprintCard project={project} />;
}
